import { apiClient } from './client';
import type { FeatureFlagKey } from './feature-flags';

export type FeatureFlagTargetRule = {
    userIds?: string[];
    userEmails?: string[];
    emailDomains?: string[];
    plans?: string[];
    statuses?: string[];
    environments?: Array<'development' | 'test' | 'production'>;
    percentage?: number;
};

export type FeatureFlagRules = {
    any: FeatureFlagTargetRule[];
};

export type ManagedFeatureFlag = {
    key: FeatureFlagKey;
    description: string;
    category: 'release' | 'beta' | 'ops' | 'experiment';
    owner: string;
    enabled: boolean;
    default_enabled: boolean;
    expose_to_client: boolean;
    rules: FeatureFlagRules;
    rules_valid: boolean;
    configured: boolean;
    expires_at: string | null;
    updated_at: string | null;
};

type UpdateManagedFeatureFlagInput = {
    enabled?: boolean;
    default_enabled?: boolean;
    rules?: FeatureFlagRules;
};

type DataResponse<T> = {
    data: T;
};

export const featureFlagAdminApi = {
    getAdminStatus: async (): Promise<{ is_admin: boolean }> => {
        return (await apiClient.get('/feature-flags/admin/me')) as unknown as {
            is_admin: boolean;
        };
    },
    listFlags: async (): Promise<ManagedFeatureFlag[]> => {
        const response = (await apiClient.get<DataResponse<ManagedFeatureFlag[]>>(
            '/feature-flags/admin',
        )) as unknown as DataResponse<ManagedFeatureFlag[]>;

        return response.data;
    },
    updateFlag: async (
        key: FeatureFlagKey,
        input: UpdateManagedFeatureFlagInput,
    ): Promise<ManagedFeatureFlag> => {
        const response = (await apiClient.patch<DataResponse<ManagedFeatureFlag>>(
            `/feature-flags/admin/${key}`,
            input,
        )) as unknown as DataResponse<ManagedFeatureFlag>;

        return response.data;
    },
};
